// React:
import React from "react";
// Routes creator:
import { BrowserRouter, Routes, Route } from "react-router-dom";
// Components:
import Main from "./components/main/Main";
import Home from "./components/main/home/Home";
import Reports from "./components/main/reports/Reports";
import EditPassword from "./components/main/eidit-password/EditPassword";
import ShareManagement from "./components/main/share-management/ShareManagement";
import Download from "./components/download/Download";
// import SignUp from "./components/authentication/sign-up/SignUp";
import Login from "./components/authentication/login/Login";
import Error from "./components/error/Error";
import UserManagement from "./components/main/user-management/UserManagement";
import CreateUser from "./components/main/user-management/create-user/CreateUser";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Main />}>
          <Route path="/" element={<Home />} />
          <Route path="reports" element={<Reports />} />
          <Route path="edit-password" element={<EditPassword />} />
          <Route path="share-management" element={<ShareManagement />} />
          <Route path="user-management" element={<UserManagement />} />
          <Route path="create-user" element={<CreateUser />} />
        </Route>
        <Route path="download/:id/:id2/:id3" element={<Download />} />
        {/* <Route path="sign-up" element={<SignUp />} /> */}
        <Route path="login" element={<Login />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
